module.exports = __webpack_public_path__ + "static/numbers-2-2-016f1f930e926abb73a283a72e7d023f.png";